<template>
  <div
    class="diff-text-card"
    :class="[{'printType':printType}]"
  >
    <div class="diff-text-card_title-wrap">
      <p class="diff-text-card_title">
        {{ noText }}
      </p>
      <p class="diff-text-card_date">
        {{ dateTitle }} <span class="diff-text-card_date-text">{{ date }}</span>
      </p>
    </div>
    <div
      v-if="comment || effects.length > 0"
      class="diff-text-card_comment-wrap"
    >
      <p class="diff-text-card_comment-title">
        {{ commentTitle }}
      </p>
      <div v-if="effects.length > 0" class="diff-text-card_comment-icon">
        <TextIcon
          v-for="(effect,effectIndex) in effects"
          :key="effectIndex"
          :text="effect.name"
          :icon="effect.icon"
        />
      </div>
      <p class="diff-text-card_comment-content">
        {{ comment }}
      </p>
    </div>
    <div class="diff-text-card__card-list">
      <LvTextCard
        outline
        original
        leading-icon="icon-warning"
        :card-content="oldText"
        :card-header="$t('修正前條文')"
        class="diff-text-card__card"
      />
      <LvTextCard
        outline
        original
        leading-icon="icon-check-circle-outline"
        :card-content="newText"
        :card-header="$t('修正後條文')"
        class="diff-text-card__card"
      />
    </div>
    <div class="diff-text-card_diff-content">
      <LvTextCard
        style="margin-top:20px"
        :diff-text="law_diff(oldText, newText)"
        :card-header="$t('修正差異')"
        leading-icon="icon-edit"
        original
        :outline="printType"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "DiffTextCard",
  props: {
    newText: {
      type: String,
      default: "",
    },
    oldText: {
      type: String,
      default: "",
    },
    noText: {
      type: String,
      default: "",
    },
    dateTitle: {
      type: String,
      default() {
        return this.$t("生效日");
      },
    },
    date: {
      type: String,
      default: "",
    },
    commentTitle: {
      type: String,
      default() {
        return this.$t("ESGoal評析");
      },
    },
    comment: {
      type: String,
      default: "",
    },
    effects: {
      type: Array,
      default() {
        return [];
      },
    },
    printType: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({}),
  methods: {
    law_diff(old_law, new_law) {
      let JsDiff = require("diff");
      let diff = JsDiff.diffChars(old_law, new_law);
      return diff;
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/diff-text-card";
</style>